<template>
  <div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      captchaObj: null,
      inited: false
    };
  },
  //   接受父组件传递的值，用来控制图形验证的加载
  props: ["isGeet"],
  methods: {
    // 初始化极验（按需初始化：仅在父组件触发时才请求 geetest_validate）
    initCaptcha() {
      let _this = this;
      //   此url是极验官网的测试请求地址，加随机数防止缓存
      return _this.$fetch("common/platform/geetest_validate?t=" + new Date().getTime()).then(res => {
        let data = res.data;
        return new Promise(resolve => {
          var handlerEmbed = function(captchaObj) {
            _this.captchaObj = captchaObj;
            _this.inited = true;
            let resolved = false;

            captchaObj
              .onSuccess(function() {
                var result = captchaObj.getValidate();
                let param = {
                  geetest_challenge: result.geetest_challenge,
                  geetest_validate: result.geetest_validate,
                  geetest_seccode: result.geetest_seccode,
                  status: data.success
                };
                _this.$emit("geetPath", param);
              })
              .onError(function() {});
            captchaObj.onReady(function() {
              if (resolved) {
                return;
              }
              resolved = true;
              resolve();
            });
          };

          _this.$initGeet(
            {
              gt: data.gt,
              challenge: data.challenge,
              product: "bind",
              offline: !data.success,
              https: true
            },
            handlerEmbed
          );
        });
      });
    },
    // 触发弹出滑块验证
    triggerVerify() {
      if (this.captchaObj) {
        this.captchaObj.verify();
      }
    }
  },

  computed: {},

  created() {},

  mounted() {},
  watch: {
    // 监听参数的变化，调用极验
    isGeet: function(val) {
      if (!val) {
        return;
      }
      if (this.inited) {
        this.triggerVerify();
        return;
      }
      this.initCaptcha().then(() => {
        if (this.isGeet) {
          this.triggerVerify();
        }
      });
    }
  }
};
</script>
<style scoped></style>
